import { useEffect, useState } from 'react'

interface CheckBoxOption {
  value: string;
  id: string | number;
}

interface CheckBoxGroupProps {
  options: CheckBoxOption[] | string[];
  name: string;
}

const CheckBoxGroup = ({ options, name }: CheckBoxGroupProps) => {
  if (options[0] instanceof String)
    options = (options as string[]).map((option: string, id: number): CheckBoxOption => ({ id, value: option }));

  const [selected, setSelected] = useState<number | string>((options[0] as CheckBoxOption).id)

  useEffect(() => {
    console.log(selected)
  }, [selected])

  const select = (id: number | string) => {
    setSelected(id);
  }

  return (
    <div className='checkbox-group flex'>
      {
        (options as CheckBoxOption[]).slice(0, 6).map((option: CheckBoxOption, i: number) => {
          return (
            <span
              onClick={() => select(option.id)}
              key={`checkbox-option-${i}`}
              className={`checkbox-option ${selected === i+1 ? '' : ''}`}
              data-selected={selected === i+1}
            >
              {/* <span className={`h-2 w-2 block rounded-full`}></span> */}
              {option.value}
            </span>
          )
        })
      }
    </div>
  )
}

export default CheckBoxGroup